const avatars = [
	{
		id: "1",
		url: "https://bcm360.nbg1.your-objectstorage.com/bcm360/s6pu4jbe6mw6/public/avatars/avatar_1.png",
	},
	{
		id: "2",
		url: "https://bcm360.nbg1.your-objectstorage.com/bcm360/s6pu4jbe6mw6/public/avatars/avatar_2.png",
	},
	{
		id: "3",
		url: "https://bcm360.nbg1.your-objectstorage.com/bcm360/s6pu4jbe6mw6/public/avatars/avatar_3.png",
	},
	{
		id: "4",
		url: "https://bcm360.nbg1.your-objectstorage.com/bcm360/s6pu4jbe6mw6/public/avatars/avatar_4.png",
	},
	{
		id: "5",
		url: "https://bcm360.nbg1.your-objectstorage.com/bcm360/s6pu4jbe6mw6/public/avatars/avatar_5.png",
	},
];

export default avatars;
